import {
  debounce, call, put, select,
} from "redux-saga/effects";
import {
  getTableFilters,
  getTablePage,
  getTablePageSize,
  getTableSorting,
  addNotification,
  changeTableItemsTotalAmount,
  setTableData,
  type Filters,
  type Sorting,
} from "@fas/ui-framework";
import { PAGES_LIST, GET_PAGES_LIST_SAGA } from "../../helpers/constants";
import { getPagesList } from "../../services/pagesApi";
import setLoading from "../../actions/loading";
import type { PagesListLoading as LoadingTypes } from "../../actions/loading";
import type { Page } from "../../components/PagesList/types/PagesList.types";

const mapIdFilterToOpenId = (filters: Filters): Filters => {
  const hasId = Object.prototype.hasOwnProperty.call(filters, "id");
  if (!hasId) return filters;

  const { id, ...rest } = filters as Filters & { id?: string };
  return { ...rest, openId: id ?? "" };
};

export function* getAllPages() {
  try {
    yield put(setLoading<LoadingTypes>(PAGES_LIST, true));

    const page: number = yield select(getTablePage, PAGES_LIST);
    const pageSize: number = yield select(getTablePageSize, PAGES_LIST);
    const rawFilters: Filters = yield select(getTableFilters, PAGES_LIST);
    const filters: Filters = mapIdFilterToOpenId(rawFilters);
    const sorting: Sorting = yield select(getTableSorting, PAGES_LIST);



    const response: {
      data: {
        data: {
          pagesList: Array<Page>,
          count: number,
        },
      }
    } = yield call(getPagesList, {
      page, pageSize, filters, sorting,
    });
    const { data: { pagesList, count } } = response.data;

    yield put(setTableData(PAGES_LIST, pagesList.map((item) => ({
      ...item,
      id: item.openId,
    }))));
    yield put(changeTableItemsTotalAmount(PAGES_LIST, count));
  }
  catch (error: any) {
    yield put(addNotification({ message: error.errorMessage, severity: "error" }));
    // eslint-disable-next-line no-console
    console.error(error);
    yield put(setTableData(PAGES_LIST, []));
    yield put(changeTableItemsTotalAmount(PAGES_LIST, 0));
  }
  finally {
    yield put(setLoading<LoadingTypes>(PAGES_LIST, false));
  }
}

export default function* watch() {
  yield debounce(1000, GET_PAGES_LIST_SAGA, getAllPages);
}
